import { __require as f } from "./main23.js";
import { __require as l } from "./main24.js";
var i, s;
function g() {
  if (s) return i;
  s = 1;
  var n = f(), u = l(), o = Object.prototype, t = o.hasOwnProperty;
  function _(r, e, a) {
    var q = r[e];
    (!(t.call(r, e) && u(q, a)) || a === void 0 && !(e in r)) && n(r, e, a);
  }
  return i = _, i;
}
export {
  g as __require
};
